import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import './theme/index.css';
import router from "./router";
import Router from "vue-router";
import "./utils/rem";

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: "medium",
})

Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
